import React, { useState } from 'react';
import { Button, TextField, Typography } from '../../design-system';
import { SwHeightPatchApi } from './useSwHeightSettingsPatch';
import { CLAMP_FIELDS } from './swHeightSettings';
import styles from './SwHeightCutoffsPanel.module.css';

export interface SwHeightCutoffsPanelProps {
  api: SwHeightPatchApi;
  /** Render the group's own heading. Off when a drawer title carries it. */
  showHeader?: boolean;
  disabled?: boolean;
}

/**
 * The bounds applied to each fitted tendency after it is evaluated, plus the
 * reservoir cut-off. Defaults reproduce the reference workbook, so the Reset
 * here restores the workbook rather than clearing the fields.
 */
export const SwHeightCutoffsPanel: React.FC<SwHeightCutoffsPanelProps> = ({
  api,
  showHeader = true,
  disabled = false
}) => {
  const { clamps, patchClamp, resetClamps } = api;
  const [showAdvancedClamps, setShowAdvancedClamps] = useState(false);

  return (
    <div className={styles.panel} data-testid="cutoffs">
      <div className={styles.header}>
        {showHeader && (
          <Typography.Text weight="semibold">Cut-offs</Typography.Text>
        )}
        <Button
          variant="ghost"
          size="sm"
          disabled={disabled}
          data-testid="reset-clamps"
          onClick={resetClamps}
        >
          Reset
        </Button>
      </div>
      {CLAMP_FIELDS.filter(
        field => !field.advanced || showAdvancedClamps
      ).map(field => (
        <TextField
          key={field.key}
          label={field.label}
          hint={field.hint}
          size="sm"
          type="number"
          fullWidth
          step={field.step}
          min={field.min}
          value={clamps[field.key]}
          disabled={disabled}
          data-testid={`clamp-${field.key}`}
          onChange={event => patchClamp(field.key, event.target.value)}
        />
      ))}
      <Button
        variant="ghost"
        size="sm"
        disabled={disabled}
        data-testid="toggle-advanced-clamps"
        onClick={() => setShowAdvancedClamps(current => !current)}
      >
        {showAdvancedClamps ? 'Hide guards' : 'Show Pe / Lambda guards'}
      </Button>
    </div>
  );
};

export default SwHeightCutoffsPanel;
